import { useRef, useState } from "react";
import { Camera, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { api, errorMessage } from "@/lib/api";

export const avatarUrl = (id, v) => `${process.env.REACT_APP_BACKEND_URL}/api/avatars/${id}?v=${v}`;

export function Avatar({ id, version, name, className = "w-16 h-16 rounded-2xl", textClass = "text-3xl" }) {
  const [broken, setBroken] = useState(false);
  if (version && !broken) {
    return <img src={avatarUrl(id, version)} alt={name} onError={() => setBroken(true)} className={`${className} object-cover shrink-0 bg-[#161618]`} />;
  }
  return (
    <div className={`${className} bg-[#E50914] flex items-center justify-center font-display font-bold shrink-0 ${textClass}`}>
      {name?.[0]?.toUpperCase() || "?"}
    </div>
  );
}

export function AvatarUpload({ user, onUser, name, className, textClass, testid = "avatar-upload" }) {
  const input = useRef(null);
  const [busy, setBusy] = useState(false);

  const pick = async (e) => {
    const file = e.target.files?.[0];
    e.target.value = "";
    if (!file) return;
    setBusy(true);
    try {
      const form = new FormData();
      form.append("file", file);
      const { data } = await api.post("/profile/avatar", form);
      onUser(data);
      toast.success("Photo updated");
    } catch (err) {
      toast.error(errorMessage(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <button type="button" data-testid={testid} onClick={() => input.current?.click()} className="relative shrink-0 group active:scale-95 transition-transform" aria-label="Change profile photo">
      <Avatar id={user.id} version={user.avatar_version} name={name ?? user.display_name} className={className} textClass={textClass} />
      <span className="absolute -bottom-1 -right-1 w-7 h-7 rounded-full bg-white text-black flex items-center justify-center border-2 border-[#0A0A0A]">
        {busy ? <Loader2 size={14} className="animate-spin" /> : <Camera size={14} />}
      </span>
      <input ref={input} type="file" accept="image/*" className="hidden" onChange={pick} data-testid={`${testid}-input`} />
    </button>
  );
}
